import { useCatalogActionsContext } from "@components/Actions/CatalogActions/CatalogActionsContext";
import ModalToOpenService from "@core-ui/ContextServices/ModalToOpenService/ModalToOpenService";
import ModalToOpen from "@core-ui/ContextServices/ModalToOpenService/model/ModalsToOpen";
import RepositoryPermissionTrigger from "@ext/enterprise/components/RepositoryPermission/RepositoryPermission";
import type RepositoryPermission from "@ext/enterprise/components/RepositoryPermission/RepositoryPermissionModal";
import { type ComponentProps, type ReactNode, useCallback } from "react";

interface RepositoryPermissionItemProps {
	children?: ReactNode;
}

const RepositoryPermissionItem = ({ children }: RepositoryPermissionItemProps) => {
	const { workspaceGesUrl, catalogName, sourceName, pathName } = useCatalogActionsContext();

	const onClick = useCallback(() => {
		ModalToOpenService.setValue<ComponentProps<typeof RepositoryPermission>>(ModalToOpen.RepositoryPermission, {
			gesUrl: workspaceGesUrl,
			pathName,
			catalogName,
			sourceName,
			onClose: () => ModalToOpenService.resetValue(),
		});
	}, [workspaceGesUrl, pathName, catalogName, sourceName]);

	return <RepositoryPermissionTrigger onClick={onClick}>{children}</RepositoryPermissionTrigger>;
};

export default RepositoryPermissionItem;
